<template>
  <div class="price-slider" id="price-slider" ref="price-slider">
    <div class="price-slider__top">
      <span class="price-slider__time" ref="price-slider__time">1h</span>
    </div>

    <div class="price-slider__box">
      <div class="price-slider__left">
        <span class="price-slider__price" ref="price-slider__price"></span>
      </div>

      <div class="price-slider__right">
        <input
          type="range"
          class="price-slider__input"
          ref="price-slider__input"
          :style="{
            '--min': inputAttributes.min,
            '--max': inputAttributes.max,
            '--val': inputAttributes.val,
          }"
          :step="inputAttributes.step"
          :min="inputAttributes.min"
          :max="inputAttributes.max"
          :value="inputAttributes.val"
        />
      </div>

      <div class="price-slider__image">
        <img
          @click="openModal"
          src="@/assets/images/Info24px.svg"
          alt="info"
          width="48px"
          height="48px"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "price-slider",
  props: {
    params: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      show: false,
      options: null,
      $input: null,
      $time: null,
      $price: null,

      inputAttributes: {
        min: 0,
        max: 0,
        val: 0,
        step: 0,
      },
    };
  },
  watch: {
    params(v) {
      this.setOptions(v);
      this.removeListeners();
      this.initInput();
    },
  },
  methods: {
    openModal() {
      this.$emit("openModal");
    },
    getTimeLabel(value) {
      const returnedValue = "1h";
      const val = parseInt(value) - this.hour_price;

      if (val == 0) {
        return returnedValue;
      }

      const periods = val / this.inputAttributes.step + 4;
      const hours = parseInt(periods / 4);
      const hoursRest = periods / 4 - hours;
      let minutes = "";

      switch (hoursRest) {
        case 0.25:
          minutes = "15m";
          break;
        case 0.5:
          minutes = "30m";
          break;
        case 0.75:
          minutes = "45m";
          break;
      }

      return `${hours}h ${minutes}`;
    },
    getThumbOffset(value) {
      const fullWidth = this.max - this.hour_price;
      const leftOffset = (value - this.hour_price) / fullWidth;

      return leftOffset * 100;
    },
    getFormattedPrice(price, hasTravelTime = false) {
      const travelPrice = 39;
      const vat = Math.ceil((price * 20) / 120);
      price = price - vat;

      if (hasTravelTime) {
        price = price - travelPrice;
      }
      return price;
    },
    setUp() {
      this.hour_price = this.getFormattedPrice(this.params.price, true);
      this.inputAttributes.step = this.getFormattedPrice(
        this.params.price_fifteen
      );
      this.max = this.hour_price + this.inputAttributes.step * 4 * 3;
    },
    setOptions(v = this.options) {
      this.options = v;
    },
    setCss(min, val, max) {
      this.inputAttributes.min = min;
      this.inputAttributes.max = max;
      this.inputAttributes.val = val;
    },
    setTimeProgress(offset) {
      this.$time.setAttribute("style", `left:${offset}%`);
    },
    setTimeLabel(value) {
      this.$time.textContent = `${this.getTimeLabel(value)}`;
    },
    setPriceText(value) {
      this.$price.textContent = `${value}€`;
    },
    prepareElements() {
      this.$input = this.$refs["price-slider__input"];
      this.$price = this.$refs["price-slider__price"];
      this.$time = this.$refs["price-slider__time"];
    },
    clearAttributes() {
      this.setCss(this.hour_price, this.hour_price, this.max);
      this.setTimeProgress(0);
      this.setPriceText(this.hour_price);
      this.setTimeLabel(this.hour_price);
    },
    initInput() {
      this.setUp();
      this.prepareElements();
      this.clearAttributes();

      const changeEvent = ({ target: { value } }) => {
        this.setPriceText(value);
        this.setTimeLabel(value);
        this.setTimeProgress(this.getThumbOffset(value));
        this.setCss(this.hour_price, value, this.max);
      };

      this.changeEvent = changeEvent;
      this.addListeners();
    },
    addListeners() {
      this.$input.addEventListener("change", this.changeEvent);
      this.$input.addEventListener("input", this.changeEvent);
    },
    removeListeners() {
      this.$input.removeEventListener("change", this.changeEvent);
      this.$input.removeEventListener("input", this.changeEvent);
    },
  },
  mounted() {
    this.setOptions();
    this.initInput();
  },
  beforeDestroy() {
    this.removeListeners();
  },
};
</script>

<style lang="scss" scoped>
.price-slider {
  font-family: sans-serif;
}

.price-slider input[type="range"] {
  -webkit-appearance: none;
  width: 100%;
  border-radius: 10px;
  outline: none;
  cursor: pointer;

  --range: calc(var(--max) - var(--min));
  --ratio: calc((var(--val) - var(--min)) / var(--range));
  --sx: calc(0.5 * 1.5em + var(--ratio) * (100% - 1.5em));
}

.price-slider input[type="range"]::-webkit-slider-runnable-track {
  font-size: var(--sx);
  height: 12px !important;
  color: #000;
  margin-top: -1px;
  width: 100%;
  height: 10px;
  background: linear-gradient(rgba(240, 116, 0, 0.623), rgba(240, 116, 0, 0.63))
    0 / var(--sx) no-repeat #ccc;
  border-radius: 10px;
}

.price-slider input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 30px;
  height: 30px;
  margin-top: -10px !important;
  border-radius: 50%;
  background: #f07300;
  margin-top: 0;
}

/* MOZILLA STYLES  */
.price-slider input[type="range"]::-moz-range-progress {
  height: 100%;
  background-color: rgba(240, 116, 0, 0.815);
  height: 12px;
  border-radius: 10px;
}

.price-slider input[type="range"]::-moz-range-track {
  height: 12px;
  background: linear-gradient(rgba(240, 116, 0, 0.623), rgba(240, 116, 0, 0.63))
    0 / var(--sx) no-repeat #ccc;
  border-radius: 10px;
}

.price-slider input[type="range"]::-moz-range-thumb {
  background: #f07300;
  border: 2px solid #f07300;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}
/* MOZILLA STYLES  */

.price-slider {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.price-slider__top {
  width: calc(100% - 255px);
  display: flex;
  justify-content: center;
  margin-left: 114px;
  height: 28px;
  position: relative;
}

.price-slider__time {
  font-size: 24px;
  font-weight: bold;
  position: absolute;
  left: 0;
  width: max-content;
}

.price-slider__box {
  width: 100%;
  display: flex;
  align-items: center;
}

.price-slider__right {
  width: calc(100% - 200px);
  padding-left: 34px;
}

.price-slider__left {
  width: 80px;
  padding-top: 10px;
}

.price-slider__image {
  width: 100px;
  display: flex;
  justify-content: flex-end;
}

.price-slider__price {
  color: #a5cb8a;
  text-transform: uppercase;
  font-family: "crossten";
  font-weight: 900;
  font-size: 40px;
  text-align: center;
  letter-spacing: 0.02em;
}

.price-slider__image img {
  cursor: pointer;
}

@media (max-width: 568px) {
  .price-slider {
    position: relative;
  }

  .price-slider__top {
    width: 98%;
    margin-bottom: 20px;
  }

  .price-slider__box {
    flex-wrap: wrap;
  }

  .price-slider__left {
    width: 98%;
  }

  .price-slider__right {
    margin-top: 15px;
    width: 100%;
    margin-left: unset;
    display: flex;
    justify-content: center;
  }

  .price-slider__top {
    margin-left: 0;
    margin-bottom: 0;
    margin-top: 70px;
  }

  .price-slider__right {
    padding-left: 0;
  }

  .price-slider__left {
    position: absolute;
    top: 0;
  }

  .price-slider__image {
    position: absolute;
    right: 0;
    top: 5px;
  }

  .price-slider__time {
    font-size: 20px;
  }
}
</style>
